import BaseStore from '../base.store';
import {fileUtil, paginationUtil} from '../../../utils';
import transactionService from './transaction.service';
import {makeObservable} from 'mobx';

class TransactionStore extends BaseStore {

    constructor() {
        super();

        makeObservable(this, {});

        this.createInitialState();
    }

    getPageableTransactions = ({startDate, endDate}, accountId = undefined, contactId = undefined) =>
        (currentPage, pageSize, sortingFields, filter, tableSelectCallback) => {

        const params = {
            accountId: accountId,
            contactId: contactId,
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            page: currentPage,
            size: pageSize,
            filter: filter,
            sort: paginationUtil.createSingleSortingParameter(sortingFields)
        };

        return transactionService.getPageableTransactions(params)
            .then(({data}) => {
                tableSelectCallback(data);
            });
    };

    exportToCsv = ({startDate, endDate}, filter, {accountId, accountName} = {}, {contactId, contactName} = {}) => {
        const params = {
            accountId: accountId,
            contactId: contactId,
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            filter
        };

        let fileName;

        if (accountName) {
            fileName = `Account transactions ${accountName}`;
        } else if (contactName) {
            fileName = `User transactions ${contactName}`;
        } else {
            fileName = 'Encompass transactions';
        }

        fileName = `${fileName} ${startDate.format('DD.MM.YYYY')} - ${endDate.format('DD.MM.YYYY')}`;

        return transactionService.getTransactionCSV(params)
            .then(({data}) => {
                fileUtil.download(data, fileName, '.csv');
            });
    };
}

const transactionStore = new TransactionStore()
export default transactionStore;